
import { Component, Vue, Prop } from "vue-property-decorator";
import { getStrings, LangKey } from "@/lib/language";
import { MerchantInfo } from "@/domain/types";

@Component
export default class PoweredBy extends Vue {
  @Prop({ default: "" }) langKey!: LangKey;
  @Prop({ default: null }) merchant!: MerchantInfo | null;

  get lang() {
    return getStrings(this.langKey);
  }
}
